/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const graphMutationSetEdgeFromClientIdMax = 36;

export const graphMutationSetEdgeFromClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const graphMutationSetEdgeToClientIdMax = 36;

export const graphMutationSetEdgeToClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const GraphMutationSetEdge = zod.object({
  carbonCopy: zod.boolean().optional(),
  certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']).optional(),
  edgeDescription: zod.string().nullish(),
  edgeKey: zod.string().nullish(),
  edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
  fromClientId: zod
    .string()
    .min(1)
    .max(graphMutationSetEdgeFromClientIdMax)
    .regex(graphMutationSetEdgeFromClientIdRegExp)
    .optional()
    .describe(
      'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
    ),
  fromContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  maxCount: zod.int().nullish(),
  minCount: zod.int().nullish(),
  position: zod.int().nullish(),
  toClientId: zod
    .string()
    .min(1)
    .max(graphMutationSetEdgeToClientIdMax)
    .regex(graphMutationSetEdgeToClientIdRegExp)
    .optional()
    .describe(
      'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
    ),
  toContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
});

export type GraphMutationSetEdge = zod.input<typeof GraphMutationSetEdge>;
export type GraphMutationSetEdgeOutput = zod.output<typeof GraphMutationSetEdge>;
